import React, { useState } from 'react';
import styles from './CandleCalendar.module.css'; // Import the CSS module
import { GoChevronLeft, GoChevronRight } from 'react-icons/go';

const CandleCalendar = props => {
  const { onChange, onClose, currentDate, monthlyTimeSlots, divRef } = props; // Extract monthlyTimeSlots from props
  const [currentMonthIndex, setCurrentMonthIndex] = useState(0);
  const currentDaySelected = new Date(currentDate).getDate();
  const today = new Date(); // Get today's date for comparison

  const date = new Date();

  // Generate the current month and the next three months
  const getMonths = () => {
    const months = [];
    for (let i = 0; i < 4; i++) {
      const month = new Date(date.getFullYear(), date.getMonth() + i, 1);
      months.push(month);
    }
    return months;
  };

  const months = getMonths(); // Get the months to display
  const currentMonth = months[currentMonthIndex]; // Get the current month

  // Get enabled dates based on time slots
  const getEnabledDates = value => {
    // const enabledDates = new Set();
    // const monthKey = currentMonth.toISOString().slice(0, 7); // Format as 'YYYY-MM'
    // // Check if the monthlyTimeSlots object has data for the current month
    // if (monthlyTimeSlots[monthKey]) {
    //   monthlyTimeSlots[monthKey].timeSlots.forEach(slot => {
    //     const start = new Date(slot.attributes.start);
    //     const end = new Date(slot.attributes.end);
    //     // Add each date in the range to the enabled set
    //     for (let dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
    //       enabledDates.add(dt.toISOString().slice(0, 10)); // Format as 'YYYY-MM-DD'
    //     }
    //   });
    // }
    // return enabledDates;
  };

  const enabledDates = getEnabledDates(); // Get the enabled dates for the current month

  // Render the calendar for the current month
  const renderCalendar = month => {
    const lastDay = new Date(month.getFullYear(), month.getMonth() + 1, 0);
    const days = [];

    for (let i = 1; i <= lastDay.getDate(); i++) {
      days.push(new Date(month.getFullYear(), month.getMonth(), i));
    }
    const checkDate = day => {
      const date = monthlyTimeSlots; // Assume monthlyTimeSlots is defined
      const targetDate = new Date(day);

      // Check if date object is valid and has at least one month with timeSlots
      if (!date || Object.keys(date).length === 0) return false;

      for (const month in date) {
        const timeSlots = date[month].timeSlots;

        // Check if timeSlots array is present and has elements
        if (!timeSlots || timeSlots.length === 0) continue;

        for (const slot of timeSlots) {
          const startDate = new Date(slot.attributes.start);
          const endDate = new Date(slot.attributes.end);

          // Check if targetDate is between startDate and endDate
          if (targetDate >= startDate && targetDate <= endDate) {
            return true;
          }
        }
      }
      return false;
    };

    return (
      <div className={styles.month}>
        <div className={styles.days}>
          {days.map(day => {
            const isEnabled = checkDate(day);
            const isToday =
              day.getDate() === today.getDate() &&
              day.getMonth() === today.getMonth() &&
              day.getFullYear() === today.getFullYear();
            return (
              <div
                key={day}
                className={`${styles.day} ${
                  day.getDate() === currentDaySelected &&
                  day.getMonth() === new Date(currentDate).getMonth() &&
                  day.getFullYear() === new Date(currentDate).getFullYear()
                    ? styles.selected_class
                    : ''
                } ${isEnabled ? '' : styles.disabled} ${isToday ? styles.today : ''}`} // Apply disabled style if not enabled
                onClick={() => {
                  if (isEnabled) {
                    onChange(day);
                    onClose();
                  }
                }}
              >
                {day.getDate()}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  // Handle next month navigation
  const handleNext = () => {
    if (currentMonthIndex < 3) {
      setCurrentMonthIndex(currentMonthIndex + 1);
    }
  };

  // Handle previous month navigation
  const handlePrevious = () => {
    if (currentMonthIndex > 0) {
      setCurrentMonthIndex(currentMonthIndex - 1);
    }
  };

  return (
    <div ref={divRef} className={styles.calendar}>
      <div className={styles.navigation}>
        <span
          onClick={handlePrevious}
          disabled={currentMonthIndex === 0}
          className={currentMonthIndex === 0 ? styles.disabled : ''}
        >
          <GoChevronLeft />
        </span>
        <h2 className={styles.h2}>
          {currentMonth.toLocaleString('default', { month: 'long' })} {currentMonth.getFullYear()}
        </h2>
        <span
          onClick={handleNext}
          disabled={currentMonthIndex === 3}
          className={currentMonthIndex === 3 ? styles.disabled : ''}
        >
          <GoChevronRight />
        </span>
      </div>
      {renderCalendar(currentMonth)} {/* Display only the current month */}
    </div>
  );
};

export default CandleCalendar;

// // src/CandleCalendar.js
// import React, { useState } from 'react';
// import styles from './CandleCalendar.module.css'; // Import the CSS module
// import { GoChevronLeft, GoChevronRight } from 'react-icons/go';

// //
// const CandleCalendar = props => {
//   const { onChange, onClose, currentDate } = props;
//   const [currentMonthIndex, setCurrentMonthIndex] = useState(0);
//   //   const [newCurrentDay, setCurrentDay] = useState(currentDay?.getDate());
//   const currentDaySeleted = new Date(currentDate).getDate();

//   const date = new Date();

//   // Generate the current month and the next three months
//   const getMonths = () => {
//     const months = [];
//     for (let i = 0; i < 4; i++) {
//       const month = new Date(date.getFullYear(), date.getMonth() + i, 1);
//       months.push(month);
//     }
//     return months;
//   };

//   const months = getMonths(); // Get the months to display
//   const currentMonth = months[currentMonthIndex]; // Get the current month

//   // Render the calendar for the current month
//   const renderCalendar = month => {
//     const lastDay = new Date(month.getFullYear(), month.getMonth() + 1, 0);
//     const days = [];

//     for (let i = 1; i <= lastDay.getDate(); i++) {
//       days.push(new Date(month.getFullYear(), month.getMonth(), i));
//     }

//     return (
//       <div className={styles.month}>
//         <div className={styles.days}>
//           {days.map(day => (
//             <div
//               key={day}
//               className={`${styles.day} ${
//                 day.getDate() === currentDaySeleted ? styles.selected_class : ''
//               }`}
//               onClick={() => {
//                 onChange(day);
//                 onClose();
//                 // setCurrentDay(day.getDate());
//                 // console.log(day.toLocaleDateString());
//               }} // Log the exact date when clicked
//             >
//               {day.getDate()}
//             </div>
//           ))}
//         </div>
//       </div>
//     );
//   };

//   // Handle next month navigation
//   const handleNext = () => {
//     if (currentMonthIndex < 3) {
//       setCurrentMonthIndex(currentMonthIndex + 1);
//     }
//   };

//   // Handle previous month navigation
//   const handlePrevious = () => {
//     if (currentMonthIndex > 0) {
//       setCurrentMonthIndex(currentMonthIndex - 1);
//     }
//   };
//   return (
//     <div className={styles.calendar}>
//       <div className={styles.navigation}>
//         <span
//           onClick={handlePrevious}
//           disabled={currentMonthIndex === 0}
//           className={currentMonthIndex === 0 ? styles.disabled : ''}
//         >
//           <GoChevronLeft />
//         </span>
//         <h2 className={styles.h2}>
//           {currentMonth.toLocaleString('default', { month: 'long' })} {currentMonth.getFullYear()}
//         </h2>
//         {/* {new Date(currentDate?.getDate())} */}
//         {}
//         <span
//           onClick={handleNext}
//           disabled={currentMonthIndex === 3}
//           className={currentMonthIndex === 3 ? styles.disabled : ''}
//         >
//           <GoChevronRight />
//         </span>
//       </div>
//       {renderCalendar(currentMonth)} {/* Display only the current month */}
//     </div>
//   );
// };

// export default CandleCalendar;
